<template>
  <b-row class="justify-content-center">
    <b-col md="8">
      <div class="form-card">
        <!-- Section Header -->
        <h2 class="form-title">Exchange Token</h2>
        <p class="form-subtitle">Generate A Long Lived Token</p>

        <b-form @submit.prevent="handleSubmit">
          <!-- Name Input -->
          <b-form-group label="Name" label-for="name" class="form-group">
            <b-form-input
              id="name"
              v-model="form.name"
              required
              placeholder="Enter a name for your token"
              class="form-input"
            ></b-form-input>
          </b-form-group>

          <!-- Access Token Input -->
          <b-form-group
            label="Short Lived Access Token"
            label-for="accessToken"
            class="form-group"
          >
            <b-form-input
              id="accessToken"
              v-model="form.accessToken"
              required
              placeholder="Enter access token"
              class="form-input"
            ></b-form-input>
          </b-form-group>
          <b-row>
            <b-col>
              <b-form-group
                label="Client ID"
                label-for="ClientId"
                class="form-group"
              >
                <b-form-input
                  id="clientId"
                  v-model="form.clientId"
                  required
                  placeholder="Enter client ID"
                  class="form-input"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Client Secret"
                label-for="clientSecret"
                class="form-group"
              >
                <b-form-input
                  id="clientSecret"
                  v-model="form.clientSecret"
                  required
                  placeholder="Enter client secret"
                  class="form-input"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Proxy Details Section -->
          <div class="proxy-section">
            <h6 class="section-title">Proxy Details</h6>

            <!-- Proxy Toggle -->
            <b-form-group class="mb-3">
              <b-form-checkbox v-model="form.useProxy" class="proxy-toggle">
                <strong>Enable Proxy for this Token</strong>
                <br />
                <small class="text-muted">
                  When enabled, all jobs using this token will route through the
                  configured proxy
                </small>
              </b-form-checkbox>
            </b-form-group>

            <b-row>
              <b-col md="6">
                <b-form-group label="Username" label-for="proxyUsername">
                  <b-form-input
                    id="proxyUsername"
                    v-model="form.proxyUsername"
                    placeholder="Enter username"
                    class="form-input"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Password" label-for="proxyPassword">
                  <b-form-input
                    id="proxyPassword"
                    v-model="form.proxyPassword"
                    type="password"
                    placeholder="Enter password"
                    class="form-input"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="Host" label-for="host">
                  <b-form-input
                    id="host"
                    v-model="form.host"
                    placeholder="Enter host"
                    class="form-input"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Port" label-for="port">
                  <b-form-input
                    id="port"
                    v-model="form.port"
                    placeholder="Enter port"
                    class="form-input"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-row>
                <b-col md="3">
                  <span>Is this proxy and IPv4 ? </span>
                </b-col>
                <b-col
                  ><b-form-checkbox id="ipv4" v-model="form.isIPV4" name="ipv4">
                  </b-form-checkbox>
                </b-col>
              </b-row> -->
          </div>

          <b-button
            type="submit"
            variant="primary"
            class="w-100 mt-4 action-btn"
            :disabled="submitting"
          >
            {{ submitting ? "Please Wait..." : "Genearte Long Lived Token" }}
          </b-button>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<style scoped>
/* General Styling */
.form-container {
  background-color: #f9fafb;
  padding: 40px;
  border-radius: 12px;
}

.form-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Typography */
.form-title {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
}

.form-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
}

/* Input Fields */
.form-group {
  margin-bottom: 20px;
}

.form-input,
.form-select,
.form-file {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 10px;
  font-size: 14px;
  background-color: white;
  transition: border 0.2s ease-in-out;
}

.form-input:focus,
.form-select:focus,
.form-file:focus {
  border-color: #0077ff;
  box-shadow: 0 0 4px rgba(99, 102, 241, 0.2);
}

/* Proxy Section */
.proxy-section {
  background: #f3f4f6;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

/* Proxy Toggle */
.proxy-toggle {
  padding: 15px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

/* Buttons */
.action-btn {
  background-color: #0077ff;
  color: white;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.action-btn:hover {
  background-color: #4f46e5;
}

.submit-btn {
  background-color: #22c55e;
  color: white;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.submit-btn:hover {
  background-color: #16a34a;
}

@media (max-width: 768px) {
  .form-container {
    padding: 20px;
  }
}
</style>

<script>
import router from "@/router";
import axios from "axios";

export default {
  data() {
    return {
      form: {
        name: "",
        accessToken: "",
        proxyUsername: "",
        proxyPassword: "",
        host: "",
        port: "",
        clientId: "",
        clientSecret: "",
        isIPV4: false,
        useProxy: true,
      },
      postTypeOptions: [
        { value: 0, text: "Photo" },
        { value: 1, text: "Reel" },
      ],
      loadingPages: false,
      pageOptions: [],
      submitting: false,
      uploadProgress: 0,
    };
  },
  methods: {
    async handleSubmit() {
      const {
        accessToken,
        name,
        proxyUsername,
        proxyPassword,
        host,
        port,
        clientId,
        clientSecret,
      } = this.form;

      if (
        !clientId ||
        !clientSecret ||
        !accessToken ||
        !name ||
        !proxyUsername ||
        !proxyPassword ||
        !host ||
        !port
      ) {
        this.$toast.error("Fill in all fields");
        return;
      }
      try {
        this.submitting = true;
        const response = await axios.post("/api/get-long-lived-token", {
          accessToken: this.form.accessToken,
          clientId: this.form.clientId,
          clientSecret: this.form.clientSecret,
          isIPV4: this.form.isIPV4,
          proxyUsername: this.form.proxyUsername,
          proxyPassword: this.form.proxyPassword,
          host: this.form.host,
          port: this.form.port,
          name: this.form.name,
          useProxy: this.form.useProxy,
        });

        if (response.data.success) {
          this.$toast.success("Automation Created Successfully");
          setTimeout(() => {
            this.uploadProgress = 0;
            router.push("/tokens");
          }, 1500);
        }
      } catch {
        this.$toast.error("Failed to generate new Token");
      }
    },
  },
};
</script>
